import React, { Fragment, useState, useContext } from "react";
import Title from "../../common/Title";
import { CirclePicker } from "react-color";
import { Store } from "../../state/state";
import { useObserver } from "mobx-react";
import { toJS } from "mobx";
import ColorPickerUI from "../../common/ColorPickerUI";
import TextField from "../../common/TextField";
import Menu from "../../common/Menu";
import FontIconPicker from "@fonticonpicker/react-fonticonpicker";
import "@fonticonpicker/react-fonticonpicker/dist/fonticonpicker.base-theme.react.css";
import "@fonticonpicker/react-fonticonpicker/dist/fonticonpicker.material-theme.react.css";
function SettingBoxCalender({ data }) {
  const store = useContext(Store);
  const [icons, setIcons] = useState("");
  console.log("HERE DATA ", data);
  const my = {
    icons: [
      "fipicon-angle-left",
      "fipicon-angle-right",
      "fipicon-angle-up",
      "fipicon-angle-down",
      "fipicon-car",
      "fipicon-github",
      "fipicon-home",
      "fipicon-trash",
    ],
    theme: "bluegrey",
    style: { postion: "absolute" },
    renderUsing: "class",
    value: icons,
    onChange: (v) => setIcons(v),
    isMulti: false,
  };
  return useObserver(() => (
    <Fragment>
      <Title>المحتوى</Title>

      <div className="w-full flex flex-col  items-center">
        <ColorPickerUI
          id={"bg-block-" + data.month + "-" + data.day}
          label={"اللون"}
          color={store.cols[data.index].color}
          onChange={(c) => {
            store.cols[data.index].color = c.hex;
          }}
        />
        <ColorPickerUI
          id={"block-text-" + data.month + "-" + data.day}
          label={"لون الخط"}
          color={store.cols[data.index].colorText}
          onChange={(c) => {
            store.cols[data.index].colorText = c.hex;
          }}
        />
        <TextField
          value={store.cols[data.index].content}
          label={"المحتوى"}
          onChangeText={(txt) => {
            store.cols[data.index].content = txt;
          }}
        />
        <Menu
          FontData
          value={store.cols[data.index].fontFamily}
          onSelect={(v) => (store.cols[data.index].fontFamily = v)}
        />
        {/* <div className="fixed">
          <FontIconPicker {...my} />
        </div> */}
        <div className="w-full flex justify-end">
          <div
            onClick={() =>
              (store.cols[data.index] = {
                ...store.cols[data.index],
                color: undefined,
                content: null,
              })
            }
            className="bg-blue-500 my-4 rounded m py-2 text-center text-white w-24 cursor-pointer hover:bg-blue-600"
          >
            <span className="fa fa-broom mx-2"></span>
            تنظيف
          </div>
        </div>
        {/* <CirclePicker
          color={store.calenderRuslt[data.month].date[data.day].color}
          onChange={(c) => {
            store.setBoxAttribute(data, "color", c.hex);
            // store.calenderRuslt[data.month].date[data.day].color = c.hex;
            console.log(toJS(store.calenderRuslt[data.month].date[data.day]));
          }}
        /> */}
      </div>
    </Fragment>
  ));
}

export default SettingBoxCalender;
